module.exports = __webpack_public_path__ + "img/2.efb78e25.png";